import apisauce from "apisauce";
import basic from "../configs/basic";


const baseUrl = basic.baseUrl;
export default class API {
  constructor(token, isBuffer) {
    this.api = apisauce.create({
      baseURL: baseUrl,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",


      },
      responseType: isBuffer ? "arraybuffer" : null,
      // responseType: "arraybuffer",
      timeout: 100000,
    });

    this.api.axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  async fetchAdminConfig(data) {
    const url = "/admin/fetchAdminConfig";
    const res = await this.api.post(url, data);
    return res;
  }

  async loginAccount(data) {
    const url = "/admin/loginAccount";
    const res = await this.api.post(url, data);
    return res;
  }

  async getOrderLog(data) {
    const url = "/order/getOrderLog";
    const res = await this.api.post(url, data);
    return res;
  }

  async getOrderReassignHistory(data) {
    const url = "/admin/getOrderReassignHistory";
    const res = await this.api.post(url, data);
    return res;
  }

  async getInboxMessageMasterList(data) {
    const url = "/admin/getInboxMessageMasterList";
    const res = await this.api.post(url, data);
    return res;
  }

  async disableInboxMessage(data) {
    const url = "/admin/disableInboxMessage";
    const res = await this.api.post(url, data);
    return res;
  }

  async searchDriver(data) {
    const url = "/driver/searchDriver";
    const res = await this.api.post(url, data);
    return res;
  }

  async getAllDriver(data) {
    const url = "/admin/getAllDriver";
    const res = await this.api.post(url, data);
    return res;
  }

  async getOrderLog(data) {
    const url = "/order/getOrderLog";
    const res = await this.api.post(url, data);
    return res;
  }

  // Driver
  async fetchDriverList(data) {
    const url = "/admin/fetchDriverList";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchVehicleList(data) {
    const url = "/admin/fetchVehicleList";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchAdminList(data) {
    const url = "/admin/fetchAdminList";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchProjectCodeList(data) {
    const url = "/admin/fetchProjectCodeList";
    const res = await this.api.post(url, data);
    return res;
  }
  
  async getOrderDashboardMonitorOrder(data) {
    const url = "/admin/getOrderDashboardMonitorOrder";
    const res = await this.api.post(url, data);
    return res;
  }

  async getRateCard(data) {
    const url = "/admin/getRateCard";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchOrderNo(data) {
    const url = "/admin/fetchOrderNo";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchOrderByOrderNo(data) {
    const url = "/admin/fetchOrderByOrderNo";
    const res = await this.api.post(url, data);
    return res;
  }

  async updateHschanRoutes(data) {
    const url = "/admin/customerAdhoc/updateHschanRoutes";
    const res = await this.api.post(url, data);
    return res;
  }


  async getHschanRoutes(data) {
    const url = "/admin/customerAdhoc/getHschanRoutes";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchChargeCodeList(data) {
    const url = "/admin/fetchChargeCodeList";
    const res = await this.api.post(url, data);
    return res;
  }


  async getOpinionCSLog(data) {
    const url = `/admin/staff/getOpinionCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async createOpinionCSLog(data) {
    const url = `/admin/staff/createOpinionCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getOpinionBasic(data) {
    const url = `/admin/staff/getOpinionBasic`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getOpinionDetail(data) {
    const url = `/admin/staff/getOpinionDetail`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getOpinionList(data) {
    const url = "/admin/staff/getOpinionList";
    const res = await this.api.post(url, data);
    return res;
  }

  async getStaffList(data) {
    const url = "/admin/staff/getStaffList";
    const res = await this.api.post(url, data);
    return res;
  }

  async getStaff(data) {
    const url = "/admin/staff/getStaff";
    const res = await this.api.post(url, data);
    return res;
  }

  async linkUpDriver(data) {
    const url = "/admin/staff/linkUpDriver";
    const res = await this.api.post(url, data);
    return res;
  }

  async getStaffPositionList(data) {
    const url = "/admin/staff/getStaffPositionList";
    const res = await this.api.post(url, data);
    return res;
  }

  async getStaffDepartmentList(data) {
    const url = "/admin/staff/getStaffDepartmentList";
    const res = await this.api.post(url, data);
    return res;
  }

  async createStaffDepartment(data) {
    const url = "/admin/staff/createStaffDepartment";
    const res = await this.api.post(url, data);
    return res;
  }

  async createStaffPosition(data) {
    const url = "/admin/staff/createStaffPosition";
    const res = await this.api.post(url, data);
    return res;
  }

  async createStaff(data) {
    const url = "/admin/staff/createStaff";
    const res = await this.api.post(url, data);
    return res;
  }


  async getProjectCodeList(data) {
    const url = "/admin/getProjectCodeList";
    const res = await this.api.post(url, data);
    return res;
  }

  async createSingleOrder(data) {
    const url = "/admin/createSingleOrder";
    const res = await this.api.post(url, data);
    return res;
  }

  async getProject(data) {
    const url = "/admin/getProject";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchExpenseType(data) {
    const url = "/expense/fetchExpenseType";
    const res = await this.api.post(url, data);
    return res;
  }

  async getProjectRemarks(data) {
    const url = "/admin/getProjectRemarks";
    const res = await this.api.post(url, data);
    return res;
  }
  async getProjectChargeCodeList(data) {
    const url = "/admin/getProjectChargeCodeList";
    const res = await this.api.post(url, data);
    return res;
  }

  async createProjectRemark(data) {
    const url = "/admin/createProjectRemark";
    const res = await this.api.post(url, data);
    return res;
  }

  async updateProject(data) {
    const url = "/admin/updateProject";
    const res = await this.api.post(url, data);
    return res;
  }

  async createRoute(data) {
    const url = "/admin/createRoute";
    const res = await this.api.post(url, data);
    return res;
  }

  async createRouteDistrictWeekdays(data) {
    const url = "/admin/createRouteDistrictWeekdays";
    const res = await this.api.post(url, data);
    return res;
  }

  async getRouteByProjectCode(data) {
    const url = "/admin/getRouteByProjectCode";
    const res = await this.api.post(url, data);
    return res;
  }

  async applyRoute(data) {
    const url = "/admin/applyRoute";
    const res = await this.api.post(url, data);
    return res;
  }

  async deleteRoute(data) {
    const url = "/admin/deleteRoute";
    const res = await this.api.post(url, data);
    return res;
  }

  async deleteRouteDistrictWeekdays(data) {
    const url = "/admin/deleteRouteDistrictWeekdays";
    const res = await this.api.post(url, data);
    return res;
  }

  async updateRoute(data) {
    const url = "/admin/updateRoute";
    const res = await this.api.post(url, data);
    return res;
  }

  async getRoute(data) {
    const url = "/admin/getRoute";
    const res = await this.api.post(url, data);
    return res;
  }

  async getRouteList() {
    const url = "/admin/getRouteList";
    const res = await this.api.post(url, {});
    return res;
  }

  async getRouteDistrictWeekdaysList(data = {}) {
    const url = "/admin/getRouteDistrictWeekdaysList";
    const res = await this.api.post(url, data);
    return res;
  }

  async getRouteDistrictWeekdays(data) {
    const url = "/admin/getRouteDistrictWeekdays";
    const res = await this.api.post(url, data);
    return res;
  }

  async updateRouteDistrictWeekdays(data) {
    const url = "/admin/updateRouteDistrictWeekdays";
    const res = await this.api.post(url, data);
    return res;
  }

  async diableAdmin(data) {
    const url = "/admin/diableAdmin";
    const res = await this.api.post(url, data);
    return res;
  }

  async diableProjectCode(data) {
    const url = "/admin/diableProjectCode";
    const res = await this.api.post(url, data);
    return res;
  }

  async createAdmin(data) {
    const url = "/admin/registerAdmin";
    const res = await this.api.post(url, data);
    return res;
  }

  async appendAdminProjectCode(data) {
    const url = "/admin/appendAdminProjectCode";
    const res = await this.api.post(url, data);
    return res;
  }

  async removeAdminProjectCode(data) {
    const url = "/admin/removeAdminProjectCode";
    const res = await this.api.post(url, data);
    return res;
  }

  async createProjectCode(data) {
    const url = "/admin/createProjectCode";
    const res = await this.api.post(url, data);
    return res;
  }

  async createVehicle(data) {
    const url = "/admin/createVehicle";
    const res = await this.api.post(url, data);
    return res;
  }

  async deleteVehicle(data) {
    const url = "/admin/deleteVehicle";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchDriverPlanList(data) {
    const url = "/admin/fetchDriverPlanList";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchDriverDetail(driverID) {
    const url = `/admin/fetchDriverDetail/${driverID}`;
    const res = await this.api.post(url, {});
    return res;
  }

  async approvalDriver(driverID) {
    const url = `/admin/approvalDriver/${driverID}`;
    const res = await this.api.post(url, {});
    return res;
  }

  async rejectDriver(driverID, rejectReason) {
    const url = `/admin/rejectDriver/${driverID}`;
    const res = await this.api.post(url, { rejectReason });
    return res;
  }

  async fetchDriverOrder(data) {
    const url = `/admin/fetchDriverOrder`;
    const res = await this.api.post(url, data);
    return res;
  }

  async submitDriverInfo(data) {
    const url = `/admin/submitDriverInfo`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updateDriverInfo(data) {
    const url = `/admin/updateDriverInfo`;
    const res = await this.api.post(url, data);
    return res;
  }

  async enableDriver(data) {
    const url = `/admin/enableDriver`;
    const res = await this.api.post(url, data);
    return res;
  }

  async removeAvatar(data) {
    const url = `/admin/removeDriverAvatar`;
    const res = await this.api.post(url, data);
    return res;
  }

  async disableAccount(data) {
    const url = `/admin/disableDriver`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchDriverSuggestion(data) {
    const url = `/admin/fetchDriverSuggestion`;
    const res = await this.api.post(url, data);
    return res;
  }

  // End Driver

  // Order
  async fetchOrderList(data) {
    const url = `/admin/fetchOrderList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async checkTrafficTicket(data) {
    const url = `/admin/checkTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async rejectTrafficTicket(data) {
    const url = `/admin/rejectTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async putBackTrafficTicket(data) {
    const url = `/admin/putBackTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async approveTrafficTicket(data) {
    const url = `/admin/approveTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async paidTrafficTicket(data) {
    const url = `/admin/paidTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getTrafficTicketList(data) {
    const url = `/admin/getTrafficTicketList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async createTrafficTicketCSLog(data) {
    const url = `/admin/createTrafficTicketCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getTrafficTicketCSLog(data) {
    const url = `/admin/getTrafficTicketCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getTrafficTicket(data) {
    const url = `/admin/getTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchOrderDetail(id) {
    const url = `/admin/fetchOrderDetail/${id}`;
    const res = await this.api.post(url, {});
    return res;
  }

  async fetchOrderForDN(id) {
    const url = `/admin/fetchOrderForDN/${id}`;
    const res = await this.api.post(url, {});
    return res;
  }

  async cancelOrder(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/cancelOrder", formData);
    return res;
  }

  async cancelBatchOrder(data) {
    const url = `/admin/cancelBatchOrder`;
    const res = await this.api.post(url, data);
    return res;
  }

  async approveBatchOrder(data) {
    const url = `/admin/approveBatchOrder`;
    const res = await this.api.post(url, data);
    return res;
  }

  async createOrderCSLog(data) {
    const url = `/admin/createOrderCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getOrderCSLog(data) {
    const url = `/admin/getOrderCSLog`;
    const res = await this.api.post(url, data);
    return res;
  }

  async putBackBatchOrder(data) {
    const url = `/admin/putBackBatchOrder`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchMemberSuggestion(data) {
    const url = `/admin/fetchMemberSuggestion`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getAddressList(data) {
    const url = `/location/getAddressList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getCustomerRecord(data) {
    const url = `/admin/customer/getCustomerRecord`;
    const res = await this.api.post(url, data);
    return res;
  }


  async getNoAvatarDriver(data) {
    const url = `/admin/staff/getNoAvatarDriver`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getCustomerRecordDetail(data) {
    const url = `/admin/customer/getCustomerRecordDetail`;
    const res = await this.api.post(url, data);
    return res;
  }

  async makeCustomerVip(data) {
    const url = `/admin/customer/makeCustomerVip`;
    const res = await this.api.post(url, data);
    return res;
  }

  async makeCustomerNotVip(data) {
    const url = `/admin/customer/makeCustomerNotVip`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getAddress(data) {
    const url = `/location/getAddress`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchAddressByCoordinates(data) {
    const url = `/location/fetchAddressByCoordinates`;
    const res = await this.api.post(url, data);
    return res;
  }

  async clearManualAddress(data) {
    const url = `/location/clearManualAddress`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updateManualAddress(data) {
    const url = `/location/updateManualAddress`;
    const res = await this.api.post(url, data);
    return res;
  }


  async fetchRouteDetail(data) {
    const url = `/location/fetchRouteDetail`;
    const res = await this.api.post(url, data);
    return res;
  }

  async submitOrder(data) {
    const url = `/admin/submitOrder`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchOrderLocation(data) {
    const url = `/admin/fetchOrderLocation`;
    const res = await this.api.post(url, data);
    return res;
  }

  async assignDriver(data) {
    const url = `/admin/assignDriver`;
    const res = await this.api.post(url, data);
    return res;
  }

  async assignDriverBatch(data) {
    const url = `/admin/assignDriverBatch`;
    const res = await this.api.post(url, data);
    return res;
  }

  // End Order

  // Dashboard
  async fetchAnalytics() {
    const url = `/admin/fetchAnalytics`;
    const res = await this.api.post(url, {});
    return res;
  }

  async fetchAverageCost(data) {
    const url = `/admin/fetchAverageCost`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchOrderDashboard(data) {
    const url = `/admin/fetchOrderDashboard`;
    const res = await this.api.post(url, data);
    return res;
  }


  async getOrderDashboardRaw(data) {
    const url = `/admin/getOrderDashboardRaw`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchDriverDashboard(data) {
    const url = `/admin/fetchDriverDashboard`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchMemberDashboard(data) {
    const url = `/admin/fetchMemberDashboard`;
    const res = await this.api.post(url, data);
    return res;
  }

  // Realtime
  async fetchDriverOrderList(data) {
    const url = `/admin/fetchDriverOrderList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async uploadDriverAvatar(data) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const url = "/admin/uploadDriverAvatar";
    const res = await this.api.post(url, data);
    return res;
  }

  async createDriver(data) {
    const url = `/admin/createDriver`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchManagerList(data) {
    const url = `/admin/fetchManagerList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async createManager(data) {
    const url = `/admin/createManager`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchChatMessage(data) {
    const url = `/manager/fetchChatMessage`;
    const res = await this.api.post(url, data);
    return res;
  }

  async submitAllowance(data) {
    const url = `/admin/submitAllowance`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchWithdrawList(data) {
    const url = `/admin/fetchWithdrawList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updateWithdrawAction(data) {
    const url = `/admin/updateWithdrawAction`;
    const res = await this.api.post(url, data);
    return res;
  }

  // Member
  async fetchMemberList(data) {
    const url = `/admin/fetchMemberList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchBusinessList(data) {
    const url = `/admin/fetchBusinessList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchMemberDetail(data) {
    const url = `/admin/fetchMemberDetail`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updateMemberStatus(data) {
    const url = `/admin/updateMemberStatus`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getDriverDepartmentList(data) {
    const url = `/admin/getDriverDepartmentList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async bulkActionTrafficTicket(data) {
    const url = `/admin/bulkActionTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }
  async bulkActionProjectCode(data) {
    const url = `/admin/bulkActionProjectCode`;
    const res = await this.api.post(url, data);
    return res;
  }
  async createProjectChargeCode(data) {
    const url = `/admin/createProjectChargeCode`;
    const res = await this.api.post(url, data);
    return res;
  }
  async deleteProjectChargeCode(data) {
    const url = `/admin/deleteProjectChargeCode`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updateTrafficTicket(data) {
    const url = `/admin/updateTrafficTicket`;
    const res = await this.api.post(url, data);
    return res;
  }

  async importOrderFile(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/importOrderFile", formData);
    return res;
  }

  async readProcessAddressXLSX(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/readProcessAddressXLSX", formData);
    return res;
  }

  async fetchAddress(data) {
    const url = "/admin/fetchAddress";
    const res = await this.api.post(url, data);
    return res;
  }

  async fetchAddress_forBulk(data, input) {
    const url = "/admin/fetchAddress";
    const res = await this.api.post(url, data);
    return { "res": res, "input": input };
  }

  async getExpense(data) {
    const url = "/expense/getExpense";
    const res = await this.api.post(url, data);
    return res;
  }

  async deleteExpense(data) {
    const url = "/expense/deleteExpense";
    const res = await this.api.post(url, data);
    return res;
  }

  async getTunnel(data) {
    const url = "/admin/fetchTunnels";
    const res = await this.api.post(url, data);
    return res;
  }


  async importOrder(data) {
    const url = "/admin/importOrder";
    const res = await this.api.post(url, data);
    return res;
  }

  async importOrderFile(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/importOrderFile", formData);
    return res;
  }

  async importDriverFile(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/importDriverFile", formData);
    return res;
  }

  async fetchCallRecord(data) {
    const url = "/log/fetchContactByOrderID"
    const res = await this.api.post(url, data)
    return res;
  }

  async getAttendance(data) {
    const url = "/attendance/getAttendance"
    const res = await this.api.post(url, data)
    return res;
  }

  async deleteAttendanceRecord(data) {
    const url = "/attendanace/deleteRecord"
    const res = await this.api.post(url, data)
    return res;
  }

  async getSchdeule(data) {
    const url = "/attendance/getSchedule"
    const res = await this.api.post(url, data)
    return res;
  }

  async updateSchedule(data) {
    const url = "/attendance/updateSchedule"
    const res = await this.api.post(url, data)
    return res
  }

  async deleteSchedule(data) {
    const url = "/attendance/deleteSchedule"
    const res = await this.api.post(url, data)
    return res
  }

  async fetchDriverDetailByPhoneNumber(data) {
    const url = "/admin/fetchDriverDetailByPhoneNumber"
    const res = await this.api.post(url, data)
    return res
  }

  async addSchedule(data) {
    const url = "/attendance/addSchedule"
    const res = await this.api.post(url, data)
    return res
  }

  async importSchedule(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/attendance/importSchedule", formData);
    return res;
  }

  async createInboxMessage(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/createFreeTextMessage", formData);
    return res;
  }

  async fetchDriverLocation(data) {
    const url = "/admin/fetchDriverLocation"
    const res = await this.api.post(url, data)
    return res
  }

  async getAllAnnouncementList(data) {
    const url = "/admin/getAllAnnouncementList"
    const res = await this.api.post(url, data)
    return res
  }

  async updateAnnouncementStatus(data) {
    const url = "/admin/updateAnnouncement"
    const res = await this.api.post(url, data)
    return res
  }

  async getInboxMessageMaster(data) {
    const url = "admin/getInboxMessageMaster"
    const res = await this.api.post(url, data)
    return res
  }

  async uploadPdf(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/uploadPdf", formData);
    return res;
  }

  async getLatestHandbook() {
    const url = "/announcement/getLatestHandbook"
    const res = await this.api.post(url)
    return res
  }

  async receiveCOD(data) {
    const url = `/admin/receiveCOD`;
    const res = await this.api.post(url, data);
    return res;
  }

  // Attendance
  async fetchAttendanceGroupList(data) {
    const url = "/admin/fetchAttendanceGroupList"
    const res = await this.api.post(url, data)
    return res
  }

  async getAttendanceGroupInfo(data) {
    const url = "/admin/getAttendanceGroupInfo"
    const res = await this.api.post(url, data)
    return res
  }

  async getAttendanceGroupMember(data) {
    const url = "/admin/getAttendanceGroupMember"
    const res = await this.api.post(url, data)
    return res
  }

  async getAttendanceData(data) {
    const url = "/admin/getAttendanceData"
    const res = await this.api.post(url, data)
    return res
  }

  async updateDriverAttendanceGroup(data) {
    const url = "/admin/updateDriverAttendanceGroup"
    const res = await this.api.post(url, data)
    return res
  }

  async createAttendanceGroup(data) {
    const url = "/admin/createAttendanceGroup"
    const res = await this.api.post(url, data)
    return res
  }

  async importScheduleFile(data) {
    const url = "/admin/importScheduleFile"
    const res = await this.api.post(url, data)
    return res
  }

  async getAttendanceSupplementList(data) {
    const url = "/admin/getAttendanceSupplementList"
    const res = await this.api.post(url, data)
    return res
  }

  async updateSupplementAttendance(data) {
    const url = "/admin/approveSupplementAttendance"
    const res = await this.api.post(url, data)
    return res
  }

  // Redpocket
  async getRedeemInfo(data) {
    const url = "/redPocket/getRedeemInfo"
    const res = await this.api.post(url, data)
    return res
  }

  async redeemRedPocket(data) {
    const url = "/redPocket/redeemPocket"
    const res = await this.api.post(url, data)
    return res
  }

  async getLatestTermCondition(data) {
    const url = "/admin/getLatestTermCondition"
    const res = await this.api.post(url, data)
    return res
  }

  async uploadTNC(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/uploadTNC", formData);
    return res;
  }

  async finishOrder(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/finishOrder", formData);
    return res;
  }

  async uploadOrderPicture(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const res = await this.api.post("/admin/uploadOrderPicture", formData);
    return res;
  }

  async getVehicleInfo(data) {
    const url = "/admin/getVehicleInfo"
    const res = await this.api.post(url, data)
    return res
  }

  async getMileageRecord(data) {
    const url = "/admin/getMileageRecord"
    const res = await this.api.post(url, data)
    return res
  }

  async resetOrder(data) {
    const url = "/admin/resetOrder"
    const res = await this.api.post(url, data)
    return res
  }

  async getDriverLocation(data) {
    const url = "/admin/getDriverLocation"
    const res = await this.api.post(url, data)
    return res
  }
  
  async monitorOrder(data) {
    const url = "/admin/monitorOrder"
    const res = await this.api.post(url, data)
    return res
  }

  async getCreateExpenseInfo(data) {
    const url = "/admin/getCreateExpenseInfo"
    const res = await this.api.post(url, data)
    return res
  }

  async createExpense(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const url = "/expense/createExpense"
    const res = await this.api.post(url, formData)
    return res
  }

  async getIRList(data) {
    const url = "/admin/fetchIRList"
    const res = await this.api.post(url, data)
    return res
  }

  async updateIRStatus(data) {
    const url = "/admin/updateIRStatus"
    const res = await this.api.post(url, data)
    return res
  }

  async searchDriver(data) {
    const url = "/driver/searchDriver"
    const res = await this.api.post(url, data)
    return res
  }

  async updateIRData(data) {
    const url = "/admin/updateIRData"
    const res = await this.api.post(url, data)
    return res
  }

  async getLeaveApprovalList(data) {
    const url = "/admin/getLeaveApprovalList"
    const res = await this.api.post(url, data)
    return res
  }

  async getLeaveApplication(data) {
    const url = "/admin/getLeaveApplication"
    const res = await this.api.post(url, data)
    return res
  }

  async updateLeaveApplicationStatus(data) {
    const url = "/admin/updateLeaveApplicationStatus"
    const res = await this.api.post(url, data)
    return res
  }

  async getCompensatoryList(data) {
    const url = "/admin/getCompensatoryList"
    const res = await this.api.post(url, data)
    return res
  }

  async createCompensatory(data) {
    const url = "/admin/createCompensatory"
    const res = await this.api.post(url, data)
    return res
  }

  async deleteCompensatory(data) {
    const url = "/admin/deleteCompensatory"
    const res = await this.api.post(url, data)
    return res
  }

  async getCompleteTimePrediction(data) {
    const url = "/admin/completeTimePrediction"
    const res = await this.api.post(url, data)
    return res
  }

  async getTableSetting(data) {
    const url = "/admin/cmsPersonalSetting/getTableSetting"
    const res = await this.api.post(url, data)
    return res
  }

  async getDriverPerformanceData(data) {
    const url = "/admin/driverPerformanceData"
    const res = await this.api.post(url, data)
    return res
  }

  async updateTableSetting(data) {
    const url = "/admin/cmsPersonalSetting/updateTableSetting"
    const res = await this.api.post(url, data)
    return res
  }

  async getAttendanceStatus(data) {
    const url = "/admin/getAttendanceStatus"
    const res = await this.api.post(url, data)
    return res
  }


  async getChatList(data) {
    const url = "/admin/chat/getChatList"
    const res = await this.api.post(url, data)
    return res
  }

  async createVote(data) {
    const url = "/admin/createVote"
    const res = await this.api.post(url, data)
    return res
  }


  async getMessages(data) {
    const url = "/admin/chat/getMessages"
    const res = await this.api.post(url, data)
    return res
  }

  async getVoteList(data) {
    const url = "/admin/fetchVoteList"
    const res = await this.api.post(url, data)
    return res
  }

  async createMessage(formData) {
    this.api.setHeader("Content-Type", "multipart/form-data");
    const url = "/admin/chat/createMessage"
    const res = await this.api.post(url, formData)
    return res
  }

  async deleteVote(data) {
    const url = "/admin/deleteVote"
    const res = await this.api.post(url, data)
    return res
  }

  async initChat(data) {
    const url = "/admin/chat/initChat"
    const res = await this.api.post(url, data)
    return res
  }

  async getChatMessageByOrderNo(data) {
    const url = "/admin/chat/getChatMessageByOrderNo"
    const res = await this.api.post(url, data)
    return res
  }

  async getVoteData(data) {
    const url = "/admin/getVoteData"
    const res = await this.api.post(url, data)
    return res
  }

  async getDriverGroupList(data){
    const url = "/admin/getDriverGroupList"
    const res = await this.api.post(url, data)
    return res
  }

  async disableDriverGroup(data){
    const url = "/admin/disableDriverGroup"
    const res = await this.api.post(url, data)
    return res
  }

  async createDriverGroup(data){
    const url = "/admin/createDriverGroup"
    const res = await this.api.post(url, data)
    return res
  }

  async getDriverGroupFeature(data){
    const url = "/admin/getDriverGroupFeature"
    const res = await this.api.post(url, data)
    return res
  }

  async updateDriverGroupPermission(data){
    const url = "/admin/updateDriverGroupPermission"
    const res = await this.api.post(url, data)
    return res
  }
  
  async getDriverGroupPermission(data){
    const url = "/admin/getDriverGroupPermission"
    const res = await this.api.post(url, data)
    return res
  }

  async getContractList(data) {
    const url = `/admin/contract/getContractList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async importForcast(data) {
    const url = `/admin/contract/importForcast`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getContractVehicleList(data) {
    const url = `/admin/contract/getContractVehicleList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getContractMonthlyDriverList(data) {
    const url = `/admin/contract/getContractMonthlyDriverList`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getContractMonthlyForcast(data) {
    const url = `/admin/contract/getContractMonthlyForcast`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getContractVehicleCost(data) {
    const url = `/admin/contract/getContractVehicleCost`;
    const res = await this.api.post(url, data);
    return res;
  }

  async updatePlanVehicle(data) {
    const url = `/admin/contract/updatePlanVehicle`;
    const res = await this.api.post(url, data);
    return res;
  }

  async getResetDriverPasswordRequest(data){
    const url = "/admin/getResetDriverPasswordRequest"
    const res = await this.api.post(url, data)
    return res
  }

  async driverResetPassword(data){
    const url = "/admin/driverResetPassword"
    const res = await this.api.post(url, data)
    return res
  }
}
